import { AfterContentInit, Component, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { usedButtonBarIcons } from 'projects/web/src/app/puzzle-button-bar/puzzle-button-bar.component';

import { DeviceDetectorService } from 'ngx-device-detector';
import { HelperFunctionsService } from '../helpers/helper-functions.service';
import { PuzzleHelpDialogService } from './puzzle-help-dialog.service';
import { ButtonBarButton } from '../buttons/button-bar-button';
import { Subscription } from 'rxjs';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { MenuController, ModalController } from '@ionic/angular/standalone';
import { PuzzleFrameworkEvents } from '../../puzzle-framework-module/puzzle-framework-events.enum';
import { LeaderboardService } from '../leaderboard/leaderboard.service';
import { TranslateModule } from '@ngx-translate/core';

import { PuzzleCompatibillityWarningComponent } from 'projects/tools/src/lib/shared-module/puzzle-compatibillity-warning/puzzle-compatibillity-warning.component';
import { PuzzleLocalstorageWarningComponent } from 'projects/tools/src/lib/shared-module/puzzle-localstorage-warning/puzzle-localstorage-warning.component';

@Component({
  selector: 'lib-app-puzzle-help-dialog',
  templateUrl: './puzzle-help-dialog.component.html',
  styleUrls: ['./puzzle-help-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonButton,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonRow,
    IonText,
    IonTitle,
    IonToolbar,
    PuzzleCompatibillityWarningComponent,
    PuzzleLocalstorageWarningComponent,
    TranslateModule,
  ],
})
export class PuzzleHelpDialogComponent implements AfterContentInit, OnDestroy {
  @ViewChild('inject', { static: true, read: ViewContainerRef }) injectViewContainerRef: ViewContainerRef;

  unsupportedBrowser = false;
  noLocalStorage = false;
  hideWarning = false;
  buttonBarButtons: Array<ButtonBarButton>;
  private helpDialogButtonBarSubscription: Subscription;
  private helpDialogSideNavSubscription: Subscription;
  sideNavButtons: Array<ButtonBarButton>;

  private helpButtonTimeout: number;
  private timesTheHelpButtonIsPressed = 0;

  showXInsteadOfCloseButton = false;
  showHelpFeedback = false;

  constructor(
    private deviceService: DeviceDetectorService,
    private helperFunctions: HelperFunctionsService,
    private helpDialogService: PuzzleHelpDialogService,
    private viewContainerRef: ViewContainerRef,
    public framework: PuzzleFrameworkService,
    private ionicModal: ModalController,
    private ionicMenu: MenuController,
    public leaderboard: LeaderboardService
  ) {
    addIcons({
      closeOutline,
    });
    addIcons(usedButtonBarIcons);

    this.helpDialogButtonBarSubscription = this.helpDialogService.buttonBarButtons$.subscribe((buttons) => {
      this.buttonBarButtons = buttons;
    });

    this.helpDialogSideNavSubscription = this.helpDialogService.sideNavButtons$.subscribe((buttons) => {
      this.sideNavButtons = buttons;
    });

    this.unsupportedBrowser = this.helperFunctions.unsupportedBrowser(
      true,
      this.framework.puzzleFrameworkConfig.nativeKeyboard
    );

    this.noLocalStorage = !this.helperFunctions.localStorageAvailable();

    this.showXInsteadOfCloseButton = this.framework.puzzleFrameworkConfig
      ? this.framework.puzzleFrameworkConfig.showXInsteadOfCloseButton
      : false;
    this.showHelpFeedback = this.framework.puzzleFrameworkConfig
      ? this.framework.puzzleFrameworkConfig.showHelpFeedback
      : false;
  }

  ngOnDestroy(): void {
    this.helpDialogButtonBarSubscription.unsubscribe();
    this.helpDialogSideNavSubscription.unsubscribe();
  }

  ngAfterContentInit(): void {
    this.helpDialogService.registerViewContainer(this.viewContainerRef, this.injectViewContainerRef);
  }

  async closeDialog(reset: boolean) {
    // this.dialogRef.close(reset);
    await this.ionicModal.dismiss();
  }

  replace_date = (str: string): string => {
    const date = new Date();
    return str.replace(/\{\{date}}/g, `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`);
  };

  onHelpButtonClicked($event: MouseEvent) {
    $event.preventDefault();

    if (!this.framework.cheatCodeEnabled()) {
      return;
    }

    if (this.helpButtonTimeout) {
      clearTimeout(this.helpButtonTimeout);
      this.helpButtonTimeout = undefined;
    }
    this.timesTheHelpButtonIsPressed++;
    this.helpButtonTimeout = window.setTimeout(async () => {
      // Close Modal and Menu before solving the puzzle to watch the solving process.
      if ([5, 6, 7, 8].indexOf(this.timesTheHelpButtonIsPressed) !== -1) {
        await this.ionicModal.dismiss();
        await this.ionicMenu.close('sidemenu');
      }
      if (this.timesTheHelpButtonIsPressed === 8) {
        throw new Error('Sentry Test error');
      } else if (this.timesTheHelpButtonIsPressed === 7) {
        this.framework.puzzleEvents.emit(PuzzleFrameworkEvents.SOLVE_CURRENT_PUZZLE);
      } else if (this.timesTheHelpButtonIsPressed === 6) {
        this.framework.puzzleEvents.emit(PuzzleFrameworkEvents.ALMOST_SOLVE_CURRENT_PUZZLE);
      } else if (this.timesTheHelpButtonIsPressed === 5) {
        this.framework.puzzleEvents.emit(PuzzleFrameworkEvents.SOLVE_CURRENT_PUZZLE_BUT_ONE);
      }
      this.timesTheHelpButtonIsPressed = 0;
    }, 500);
  }
}
